import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// import Swiper JS
import Swiper from "swiper";
// core version + navigation, pagination modules:
import SwiperCore, {
    Navigation,
    Pagination,
    Mousewheel,
    Thumbs,
    Lazy,
} from "swiper/core";
// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Mousewheel, Thumbs, Lazy]);

// import Swiper styles
import "swiper/swiper-bundle.css";

/***
 * ANIMAZIONE HOMEPAGE
 */
const scrollerHomepage = document.querySelector("#home-video-zoom");
if (scrollerHomepage !== null) {
    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.defaults({
        // Defaults are used by all ScrollTriggers
        toggleActions: "restart pause resume pause", // Scoll effect Forward, Leave, Back, Back Leave
        markers: false, // Easaly remove markers for production
    });

    const timelineHeader = gsap.timeline({
        scrollTrigger: {
            id: "ZOOM", // Custom label to the marker
            trigger: "#home-video-zoom", // What element triggers the scroll
            scrub: 0.5, // Add a small delay of scrolling and animation. `true` is direct
            start: "top +=50%", // Start at top of Trigger and at the top of the viewport
            end: "+=50% +=50%", // The element is 500px hight and end 50px from the top of the viewport
            pin: false, // Pin the element true or false
        },
    });
    var zoomfrom = 0.35;
    var zoomto = 1;

    timelineHeader.set(".video-zoom", {
        scale: zoomfrom,
        transformOrigin: "center",
    });

    timelineHeader.to(
        ".video-zoom",
        {
            scale: zoomto,
        },
        "sameTime"
    );
}

$(document).ready(function () {
    var windowWidthOnce = window.innerWidth
        ? window.innerWidth
        : $(window).width();

    ScrollTrigger.refresh();

    $.fn.isInViewport = function () {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    var video = document.querySelectorAll("video");

    //add source to video tag
    function addSourceToVideo(element, src) {
        if (element.childElementCount == 0) {
            var source = document.createElement("source");
            source.src = src;
            source.type = "video/mp4";
            element.appendChild(source);
        }
    }

    //determine screen size and select mobile or desktop vid
    function whichSizeVideo(element, src) {
        var windowWidth = window.innerWidth
            ? window.innerWidth
            : $(window).width();
        if (windowWidth > 768) {
            addSourceToVideo(element, src.dataset.desktopVid);
        } else {
            // disabilito i video in modalità mobile (non servono)
            addSourceToVideo(element, src.dataset.mobileVid);
        }
    }

    //init only if page has videos
    function videoSize() {
        if (video !== undefined) {
            video.forEach(function (element, index) {
                if ($(element).isInViewport()) {
                    whichSizeVideo(
                        element, //element
                        element //src locations
                    );
                    if (!element.autoplay) {
                        element.classList.add("lazyloaded");
                        element.autoplay = true;
                        element.load();
                    }
                }
            });
        }
    }
    videoSize();

    var lastScrollTop = 0;
    var lastdirection = "down";
    var changeddirection = 0;
    $(window).on("resize scroll", function () {
        if ($(".header-video-bg").length > 0) {
            videoSize();
        }
    });

    $(window).on("scroll", function () {
        var st = $(this).scrollTop();
        if (st < lastScrollTop) {
            //console.log('up 1');
            if (lastdirection != "up") {
                lastdirection = "up";
                changeddirection = 1;
            }
        } else {
            //console.log('down 1');
            if (lastdirection != "down") {
                lastdirection = "down";
                changeddirection = 1;
            }
        }
        lastScrollTop = st;
        if (changeddirection == 1) {
            changeddirection = 0;
            $(".slideshowbrands").toggleClass("counterclockWise");
            $(".recycledmaterials-container").toggleClass("counterclockWise");
        }
    });

    var selid = "";
    $('input[name="tab-control"]').on("change", function () {
        if ($(this).is(":checked")) {
            selid = $(this).attr("id");
            console.log("#" + selid + "-data");
            let showCaseSlider = $("#" + selid + "-data").find(
                ".swiper-container"
            );
            let showCaseSliderInstance = showCaseSlider[0].swiper;
            showCaseSliderInstance.update();
        }
    });

    $("body").on("click", ".divisioncard-opener", function () {
        $(".divisioncard-opener")
            .not(this)
            .each(function (index, value) {
                $(this).parent().removeClass("activemobileaccordion");
            });
        $(this).parent().toggleClass("activemobileaccordion");
    });
});
